const RegionMetadataLang = {
    fr: {
        dropDown: {
            0: 'Abitibi-Témiscamingue',
            1: 'Bas-Saint-Laurent',
            2: 'Capitale-Nationale',
            3: 'Chaudière-Appalaches',
            4: 'Côte-Nord',
            5: 'Estrie',
            6: 'Gaspésie-Îles-de-la-Madeleine',
            7: 'Lanaudière',
            8: 'Laurentides',
            9: 'Laval',
            10: 'Mauricie-et-Centre-du-Québec',
            11: 'Montérégie',
            12: 'Montréal',
            13: 'Nord-du-Québec',
            14: 'Nunavik',
            15: 'Outaouais',
            16: 'Saguenay-Lac-Saint-Jean',
            17: 'Terres-Cries-de-la-Baie-James',
        },
    },
    en: {
        dropDown: {
            0: 'Abitibi-Témiscamingue',
            1: 'Bas-Saint-Laurent',
            2: 'Capitale-Nationale',
            3: 'Chaudière-Appalaches',
            4: 'Côte-Nord',
            5: 'Estrie',
            6: 'Gaspésie-Îles-de-la-Madeleine',
            7: 'Lanaudière',
            8: 'Laurentides',
            9: 'Laval',
            10: 'Mauricie-et-Centre-du-Québec',
            11: 'Montérégie',
            12: 'Montréal',
            13: 'Nord-du-Québec',
            14: 'Nunavik',
            15: 'Outaouais',
            16: 'Saguenay-Lac-Saint-Jean',
            17: 'Terres-Cries-de-la-Baie-James',
        },
    },
};

export default RegionMetadataLang;
